var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.2,
    height: 12.148,
    viewBox: "0 0 16.2 12.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173394"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27338",
    d: "M-625.058-25.378a.943.943 0 0 1-.942-.942v-10.263a.944.944 0 0 1 .942-.943h14.316a.943.943 0 0 1 .941.943v10.263a.942.942 0 0 1-.941.941zm.1-1.041h14.116v-10.063h-14.116zm5.606-1.7 1.862-6.949 1.038.278-1.862 6.949zm.9.033-.651-.175zm2.492-1.486 1.88-1.884-1.88-1.883.758-.758 2.641 2.641-2.641 2.642zm.758.474-.475-.474zm1.4-2.358-1.88-1.883zm-9.435 0 2.641-2.641.758.758-1.88 1.883 1.88 1.884-.758.758zm2.641 2.358-2.358-2.358z",
    transform: "translate(626 37.526)",
    style: {
      fill: "#203662"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeNewIcon);
export default __webpack_public_path__ + "static/media/CodeNewIcon.e75688ef49e095f131ad3c290294f303.svg";
export { ForwardRef as ReactComponent };